import s from "styled-components";
import Paper from "_c/Paper";

export const Wrap = s(Paper)`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 18px auto;
  @media(max-width: 550px) {
    max-width: 95%;
  }
`;
export const AttachPhotoButton = s.button`
  border: 2px solid #CBC7C7;
  border-radius: 24px;
  color: #CBC7C7;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 18px;
  transition all .35s ease-in-out;
  @media(max-width: 400px) {
    &&& {
      align-self: auto;
    }
  }
  :hover {
    color: white;
    background-color: #CBC7C7;
  }
`;

export const Thumb = s.img`
  display: block;
  max-width: 240px;
  margin-bottom: 20px;
  border-radius: 9px;
  height: auto;
  object-fit: cover;
`;
